import type { NotificationsSettingsButtonProps } from "./notifications-settings-button.type";

import { SettingOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { TAB_KEYS } from "@/constants/TabKeys";
import { useNotificationsPanel } from "@/modules/notifications/notifications-panel";

export const NotificationsSettingsButton = ({
  tooltip,
}: NotificationsSettingsButtonProps) => {
  const { t } = useTranslation();
  const { closePanel } = useNotificationsPanel();

  return (
    <Tooltip
      title={t("notification:settingsButton")}
      placement={tooltip?.placement}
      align={tooltip?.align}
    >
      <Link
        to={`/preferences?tab=${TAB_KEYS.PREFERENCES_NOTIFICATIONS}`}
        aria-label={t("notification:settingsButton")}
        onClick={closePanel}
      >
        <SettingOutlined />
      </Link>
    </Tooltip>
  );
};
